import axiosInstance from "services/common/axiosInstance";

export interface ImportExcelFileParams {
  file_url: string;
}

export interface ImportExcelFileResponse {
  success: boolean;
  message?: string;
  data?: unknown;
}

export const importExcelFile = async (
  params: ImportExcelFileParams
): Promise<ImportExcelFileResponse> => {
  const { data } = await axiosInstance.post<ImportExcelFileResponse>(
    "/lic/importexcelfile",
    params
  );
  return data;
};
